import Vue from "vue";

import {PersonnelService,} from "@/common/api.service";
import {FETCH_TEAM_LIST, SAVE_EDITED_TEAM, SAVE_NEW_TEAM, DELETE_TEAM} from "./actions";
import {FETCH_TEAM_LIST_END, FETCH_TEAM_START, SET_TEAM, UPDATE_MANAGE_COMPANY_FIELD, LOAD_TEAM_TO_EDIT, RESET_DEFAULT_NEW_TEAM, RESET_DEFAULT_NEW_TEAM_LIST, 
    RESET_DEFAULT_TEAM_TO_EDIT, TOGGLE_EDIT_TEAM_DIALOG, TOGGLE_NEW_TEAM_DIALOG, UPDATE_TEAM_FIELD, UPDATE_ADD_TEAM_FIELD} from "./mutations";
import {SET_TOASTER_MESSAGE} from "../this_app/mutations";

const getDefaultState = () => {
    return {
        loadingEcsCompany: false,
        team: {
            name: '',
        },
        teamList: [],
        editTeamDialog: false,
        addTeam: {
            name: '',
            isActive: true,
        },
        editTeam: {
            isActive: true
        },
        addTeamDialog: false,
    }
};

const state =
{
    loadingEcsCompany: false,
    team: {},
    teamList: [],
    editTeamDialog: false,
    addTeam: {
        name: '',
        isActive: true
    },
    editTeam: {
        isActive: true
    },
    addTeamDialog: false,
};

const getters = {
    team(state) {
        return state.team;
    },
    teamList(state) {
        return state.teamList;
    },
    editStateTeams(state) {
        return state.editStateTeams;
    },
    getTeamNameById: (state) => (teamId) => {
        const team = state.teamList.find(team => team.teamId == teamId);
        if (team) {
            return team.name;
        }
    },
    addTeamDialog(state) {
        return state.addTeamDialog;
    },
};

const actions = {
    [FETCH_TEAM_LIST]({commit}) {
        return PersonnelService.getAllTeams()
            .then(({data}) => {
                commit(FETCH_TEAM_LIST_END, data);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to fetch teams'});
            });
    },
    [SAVE_EDITED_TEAM]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const editedTeam = state.editTeam;
        return PersonnelService.updateTeam(editedTeam)
        .then(({data}) => {
            commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record updated'});
            commit(RESET_DEFAULT_TEAM_TO_EDIT);
            dispatch(FETCH_TEAM_LIST);
            return data;
        })
        .catch(error => {
            Vue.rollbar.error(error);
            commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to update team'});
        });
    },

    [SAVE_NEW_TEAM]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const newTeam = state.addTeam;
        return PersonnelService.saveTeam(newTeam)
        .then(() => {
            commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record saved'});
            dispatch(FETCH_TEAM_LIST);
            // return data;
        })
        .catch(error => {
            Vue.rollbar.error(error);
            commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to save team'});
        });
    },


    [DELETE_TEAM]({dispatch, commit}, params) {
        return PersonnelService.deleteTeam(params.teamId)
        .then(({data}) => {
            commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record deleted'});
            dispatch(FETCH_TEAM_LIST);
            return data;
        })
        .catch(error => {
            Vue.rollbar.error(error);
            commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to delete team'});
        });
    },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [UPDATE_MANAGE_COMPANY_FIELD](state, data) {
        state.team[data.field] = data.value;
    },
    [FETCH_TEAM_START](state) {
        state.loadingEcsCompany = true;
    },
    [FETCH_TEAM_LIST_END](state, data) {
        state.teamList = data;
    },
    [SET_TEAM](state, data) {
        state.team = data;
    },
    [UPDATE_ADD_TEAM_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.addTeam[data.objectKey][0][data.key] = data.value;
        } else {
            state.addTeam[data.key] = data.value;
        }
    },
    [UPDATE_TEAM_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.editTeam[data.objectKey][0][data.key] = data.value;
        } else {
            state.editTeam[data.key] = data.value;
        }
    },
    [RESET_DEFAULT_NEW_TEAM](state) {
        state.addTeam = getDefaultState().team;
    },
    [RESET_DEFAULT_NEW_TEAM_LIST](state) {
        // state.teamList = [];
        state.employedDates = [];
        state.teamList = getDefaultState().teamList;
    },
    [TOGGLE_NEW_TEAM_DIALOG](state) {
        state.addTeamDialog = !state.addTeamDialog;
    },
    [TOGGLE_EDIT_TEAM_DIALOG](state) {
        state.editTeamDialog = !state.editTeamDialog;
    },
    [LOAD_TEAM_TO_EDIT](state, teamId) {
        // noinspection UnnecessaryLocalVariableJS
        const itemToEdit = state.teamList.find(
        (list) => list.teamId == teamId
        );
        state.editTeam = itemToEdit;
    },
    [RESET_DEFAULT_TEAM_TO_EDIT](state) {
        state.editTeam = getDefaultState().team;
    },
};


export default {
    state,
    getters,
    actions,
    mutations,
};
